<template>
  <div>
    <span v-if="debug === 'true' || debug === true">{{version}}</span>
    <Header></Header>
    <b-container fluid>

      <b-row class="titulo">
        <b-col class="seccionTitulo">
          <span class="fa fa-table"></span>
          <span>Facturas Globales</span>
        </b-col>
        <b-col class="seccionCodigo">
          <div>FG_01_factura_global</div>
        </b-col>
      </b-row>

      <b-row>
        <b-col class="subtitulos">
          Administracion de  Facturas
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-tabs content-class="mt-3">
            <b-tab title="Facturas Globales" active>
              <FacturasGlobales></FacturasGlobales>
            </b-tab>
            <b-tab title="Recibos">
              <Recibos></Recibos>
            </b-tab>
<!--            <b-tab title="Disabled" disabled><p>I'm a disabled tab!</p></b-tab>-->
          </b-tabs>
        </b-col>
      </b-row>
    </b-container>

  </div>

</template>

<script>
import FacturasGlobales from "@/components/reportes/FacturasGlobales";
import Header from "@/components/Header";
import Recibos from "@/components/reportes/Recibos";
export default {
name: "AdministracionFacturas",
  components: {Recibos, Header, FacturasGlobales},
  data: () => ({
    version: process.env.VUE_APP_ENV_VERSION,
    debug: false,
  }),
  created() {
    this.debug = this.$localStorageService.getDebug();
  },
}
</script>

<style scoped>

</style>
